import { useSelector } from "react-redux";
import FacilityAccordion from "../../../components/UI/Accordion/FacilityAccordion/FacilityAccordion";
import Strings from "../../../resources/Strings";
import Details from "./Details";
import classes from "./Details.module.css";

const ParkerDetails = (props) => {
  const userSitesIds = useSelector((state) => {
    return state.user?.sites;
  }).map((site) => site.id);
  const allowedUserSites = props?.utronUser?.userSites?.filter((userSite) =>
    userSitesIds.includes(userSite.siteId)
  );
  return (
    <Details {...props}>
      <span className={classes.subTitle}>
        {Strings.USER_INFO.FACILITY_AND_CAR}
      </span>
      <div className={classes.detailsAccordion}>
        {allowedUserSites?.map((site) => (
          <FacilityAccordion
            key={site.id}
            {...site}
            {...props}
            isViewMode={props.isViewMode}
          ></FacilityAccordion>
        ))}
      </div>
    </Details>
  );
};

export default ParkerDetails;
